<template>
  <Layout :footer-style="2">
    <!-- Start Slider Area -->
     <div class="home">
       <div class="">
         <div class="inner home-banner">
           <banner></banner>
         </div>
       </div>
       <div id="Home-ai">
         <div class="position-relative" data-aos="fade-up" v-for="(item, index) in tabList" :key="index">
           <div class="container tab-block" :class="item.type == 1 ? 'tab-block-left' : 'tab-block-right'">
             <img class="title_img" :src="item.titleImg" alt="" /> 
             <div class="tab-content">
               <div class="tab-content-text">
                 <div v-for="(text, index) in item.list" :key="index" class="tab-block-text">
                   <div><i class="bi bi-check-circle-fill mg-r-8" style="color: #1571EC;"></i></div><span v-html="text.text"></span>
                 </div>
               </div>
               <div class="tab-btn" @click="handleClick(index)">即刻体验<i class="bi bi-arrow-right tab-btn-icon"></i></div>
             </div>
           </div>
           <div class="bg-block">
             <img :src="item.img" alt="" />
           </div>
         </div>
       </div>
       <div id="home-logo" class="animate__animated">
         <div class="">
           <div class="font-size-24 fw-bold text-center lyd-title-colo1 text-balck" data-aos="fade-up">超500家集团企业用户，提供百余种业务场景AI应用实践</div>
           <div class="company">
             <vue-seamless-scroll :data="companyall" :class-option="defaultOption" data-aos="fade-right">
               <div class="companymain">
                 <div class="companyitem" v-for="(log, j) in companyall" :key="j">
                   <img class="logoimg" :src="log.logo" alt="" />
                 </div>
               </div>
             </vue-seamless-scroll>
             <vue-seamless-scroll :data="companyall2" :class-option="defaultOption2" data-aos="fade-left">
               <div class="companymain">
                 <div class="companyitem" v-for="(log, j) in companyall2" :key="j">
                   <img class="logoimg" :src="log.logo" alt="" />
                 </div>
               </div>
             </vue-seamless-scroll>
           </div>
         </div>
       </div>
     </div>
  </Layout>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import Layout from "../../components/common/Layout";
import banner from "../../components/common/banner/indexNew.vue";
import Icon from "../../components/icon/Icon";
import seamlescroll from "../../components/common/seamlescroll/index.vue";
import vueSeamlessScroll from "vue-seamless-scroll";

export default {
  name: "home",
  components: { Icon, Layout, banner, swiper, swiperSlide, seamlescroll, vueSeamlessScroll },
  data() {
    return {
      companyall: [
        {
          logo: require("@/assets/newImages/seamless-logo/1@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/2@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/3@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/4@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/5@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/6@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/7@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/8@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/9@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/10@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/11@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/12@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/13@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/14@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/15@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/16@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/17@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/18@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/19@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/20@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/21@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/22@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/23@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/24@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/25@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/26@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/27@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/28@2x.png"),
        },
      ],
      companyall2:[
        {
          logo: require("@/assets/newImages/seamless-logo/1@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/2@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/3@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/4@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/5@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/6@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/7@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/8@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/9@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/10@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/11@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/12@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/13@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/14@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/15@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/16@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/17@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/18@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/19@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/20@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/21@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/22@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/23@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/24@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/25@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/26@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/27@2x.png"),
        },
        {
          logo: require("@/assets/newImages/seamless-logo/28@2x.png"),
        },
      ],
      tabList: [
        {
          type: 1,
          img: require("@/assets/newImages/home/元生平台_bj@2x.png"),
          titleImg: require("@/assets/newImages/home/元生平台_文字_png@2x.png"),
          list: [
            {
              text: `企业级AI大模型一站式元生平台`,
            },
            {
              text: `基于云原生分布式计算架构的AI低代码开发套件支持多种主流AI深度学习框架的可视化开发`,
            },
            {
              text: `助力用户设计和构建各种AI算法和模型，并提供便捷的开发环境、丰富的功能组件和高性能的算力资源`,
            },
          ],
        },
        {
          type: 2,
          img: require("@/assets/newImages/home/数据智能体_bj@2x.png"),
          titleImg: require("@/assets/newImages/home/数据智能体_文字_png@2x.png"),
          list: [
            {
              text: `融合AI智能体、知识图谱与多Agent协同架构的新一代数据智能平台`,
            },
            {
              text: `基于行业知识与企业特性，自动完成数据采集、清洗、分析、洞察乃至策略推荐的全过程`,
            },
            {
              text: `通过多个智能体高效协作，实现无人值守、实时响应、持续优化的智能决策体验`,
            },
          ],
        },
        {
          type: 1,
          img: require("@/assets/newImages/home/AI审核_bj@2x.png"),
          titleImg: require("@/assets/newImages/home/AI审核_文字_png@2x.png"),
          list: [
            {
              text: `通过AI技术实现审核全流程自动化，涵盖智能填单、审核到记账的一站式、端到端解决方案`,
            },
            {
              text: `结合了机器学习、自然语言处理（NLP)、大数据分析等先进技术，快速、准确地识别合同中的关键条款、潜在风险点并提出修改和优化建议`,
            }
          ],
        },
        {
          type: 2,
          img: require("@/assets/newImages/home/智慧网银_bj@2x.png"),
          titleImg: require("@/assets/newImages/home/智慧网银_文字_png@2x.png"),
          list: [
            {
              text: `结合了机器学习、自然语言处理（NLP)、大数据分析等先进技术，快速、准确地识别合同中的关键条款、潜在风险点并提出修改和优化建议`,
            },
            {
              text: `电子回单统一管理，并构建了统一的票据统一签收平台，并对票据管理存在的风险提前进行预警`,
            },
            {
              text: `银行流水自动对账出具余额调节表，并自动出具银行调节表`,
            },
            {
              text: `多维度资金管控可视，结合预测分析，提升资金预测效益`,
            },
          ],
        },
      ],
    };
  },
  computed: {
    defaultOption() {
      return {
        step: 0.3, // 数值越大速度滚动越快
        limitMoveNum: 5, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
    defaultOption2() {
      return {
        step: 0.3, // 数值越大速度滚动越快
        limitMoveNum: 5, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 3, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  created() {
    
  },
  mounted() {
    // 页面加载时打乱logo顺序
    this.companyall = this.shuffleArray(this.companyall);
    this.companyall2 = this.shuffleArray(this.companyall2);
  },
  methods: {
    //  Fisher-Yates 洗牌算法
    shuffleArray(array) {
      const shuffled = [...array];//创建副本，避免修改原数组
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }
      return shuffled;
    },
    handleClick(index) {
      if (index == 0) {
        this.$router.push({
          path: '/ai-page',
        })
      } else if (index == 1) {
        this.$router.push({
          path: '/product-solution/1',
        })
      } else if (index == 2) {
        this.$router.push({
          path: '/product-solution/2',
        })
      } else if (index == 3) {
        this.$router.push({
          path: '/product-solution/3',
        })
      }
    },
  },
};
</script>
<style lang="scss">
.home{
  margin: 0 auto;
  max-width: 1920px;
}
.company {
  overflow: hidden;
  // display: flex;
}
.companymain {
  width: 100%;
  height: 100%;
  display: flex;
}
.companyitem {
  width: 200px;
  // height: 70px;
  margin: 12px;
  padding: 20px;
  position: relative;
  text-align: center;
  // opacity: 0.8;
  border-radius: 4px;
  background-color: #fff;
  flex-shrink: 0;
  cursor: pointer;
  box-shadow: 0 6px 18px -1px #f8f8f8;
  // border: 1px solid red;
  .companyitem-bj {
    width: 100%;
    height: 100%;
  }
  .logoimg {
    // position: absolute;
    max-height: 60px;
  }
}
</style>
